import React from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { Outlet, Navigate, useLocation } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import Login from "@/pages/Login";

export default function AppLayout() {
  const { authed, authReady } = useApp();
  const location = useLocation();

  if (!authReady) {
    return (
      <div className="min-h-screen flex items-center justify-center" style={{ background: "#F0F6F1" }}>
        <div className="text-sm font-medium text-[#0E5B52]">Loading admin session…</div>
      </div>
    );
  }

  if (!authed) {
    return location.pathname === "/" ? <Login /> : <Navigate to="/" replace />;
  }

  return (
    <div className="min-h-screen flex" style={{ background: "#F0F6F1" }}>
      <Sidebar />
      <div className="flex-1 md:ml-64 flex flex-col min-h-screen">
        <Topbar />
        <main className="flex-1 px-4 md:px-8 py-6 max-w-[1500px] w-full">
          <div className="animate-fade-up">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
}
